<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-truck-ramp-box"></i></span>{{ 'Menu.Menu.ReceivingRegistration' | translate }}</h1>

  <div class="grid">
    <div class="col">
        <button pButton pRipple label="{{ 'ReceivingRegistration.Button.Import' | translate }}" class="p-button ml-2" (click)="importClick()"></button>
    </div>
  </div>

  <p-card>
    <form [formGroup]="createForm">

      <div class="p-fluid formgrid grid">

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.Forwarder' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="shipper" optionLabel="optionDesc" optionValue="optionCode"
              [options]="bookingForwarderOptions" [filter]="true" filterBy="optionDesc" (onChange)="changeBillObject(1)"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}" ></p-dropdown>

            <div *ngIf="((submitted || createForm.controls.shipper.touched) && createForm?.controls?.shipper?.errors?.required )" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.PayeeType' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="billObjectType" optionLabel="label" optionValue="value"
            [options]="billObjectTypeOptions" [filter]="true" (onChange)="changeBillObject(2)" ></p-dropdown>

            <div *ngIf="((submitted || createForm.controls.billObjectType.touched) && createForm?.controls?.billObjectType?.errors?.required)" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.Payee' | translate }}</label>
          <div class="item" >
            <p-dropdown formControlName="billObject" optionLabel="label" optionValue="value"
              [options]="billObjectOptions" [filter]="true" placeholder="{{ 'Common.Message.ChooseOption' | translate }}" >
            </p-dropdown>

            <div *ngIf="((submitted || createForm.controls.billObject.touched) &&  createForm?.controls?.billObject?.errors?.required )" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>

          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span *ngIf="updateValidity(createForm.controls.vendorCustomer)" class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.Supplier' | translate }}</label>
          <div class="item">
            <p-autoComplete formControlName="vendorCustomer" [suggestions]="vendorSuggests" (completeMethod)="getVendorOptions($event)"></p-autoComplete>

            <div *ngIf="((submitted || createForm.controls.vendorCustomer.touched) && createForm?.controls?.vendorCustomer?.errors?.required)" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>


        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.DocumentType' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="deliveryType" optionLabel="label" optionValue="value"
              [options]="deliveryOptions" [filter]="true"  (onChange)="changeValidation()"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}" ></p-dropdown>

              <div *ngIf="((submitted || createForm.controls.deliveryType.touched) && createForm?.controls?.deliveryType?.errors?.required)" >
                <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
              </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.Company' | translate }}</label>
          <div class="item">
            <p-dropdown #dd formControlName="orgId" optionLabel="label" optionValue="value"
              [options]="letterHeadOptions" [filter]="true"   (onChange)="getBillCorpOptions()"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}" ></p-dropdown>

              <div *ngIf="((submitted || createForm.controls.orgId.touched) && createForm?.controls?.orgId?.errors?.required)" >
                <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
              </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.BillCompany' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="billCorp" optionLabel="label" optionValue="value"
            placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [options]="billCorpOptions" [filter]="true" ></p-dropdown>

            <div *ngIf="((submitted || createForm.controls.billCorp.touched) && createForm?.controls?.billCorp?.errors?.required)" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>
        <!-- 起運地位置選擇 - 使用連動元件 -->
        <laas-location-cascade-dropdown
          formControlName="fromLocation"
          [showCountry]="true"
          [showCity]="true"
          [showArea]="true"
          [showExpressArea]="false"
          [showDistrict]="false"
          [showValidation]="true"
          [submitted]="submitted"
          [requiredFields]="['country','city']"
          countryLabel="{{ 'ReceivingRegistration.MainTable.OriginCountry' | translate }}"
          cityLabel="{{ 'ReceivingRegistration.MainTable.OriginCity' | translate }}"
          areaLabel="{{ 'ReceivingRegistration.MainTable.OriginArea' | translate }}"
          countryPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          cityPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          areaPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          [allowAllOption]="false"
          [showClear]="true"
          [enableFilter]="true"
          [cssClasses]="'col-12 md:col-6 lg:col-3 mb-3'">
        </laas-location-cascade-dropdown>

        <!-- 目的地位置選擇 - 使用連動元件 -->
        <laas-location-cascade-dropdown
          formControlName="toLocation"
          [showCountry]="true"
          [showCity]="true"
          [showArea]="true"
          [showExpressArea]="false"
          [showDistrict]="false"
          countryLabel="{{ 'ReceivingRegistration.MainTable.DestinationCountry' | translate }}"
          cityLabel="{{ 'ReceivingRegistration.MainTable.DestinationCity' | translate }}"
          areaLabel="{{ 'ReceivingRegistration.MainTable.DestinationArea' | translate }}"
          countryPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          cityPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          areaPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          [allowAllOption]="false"
          [showClear]="true"
          [enableFilter]="true"
          [cssClasses]="'col-12 md:col-6 lg:col-3 mb-3'"
          [virtualScroll]="true"
          [itemSize]="10"
          >
        </laas-location-cascade-dropdown>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.CourierDeliveryCondition' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="expressTerm"  optionLabel="label" optionValue="value"  [options]="expressTermOptions" [showClear]="true"
               [filter]="true" [disabled]="!isExpressTermEdit" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  styleClass="p-text-left">
            </p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.DeclarationType' | translate }}</label>
          <div class="item">
              <p-dropdown formControlName="docType"  optionLabel="label" optionValue="value"  [options]="docTypeOptions" [showClear]="true"
                 [filter]="true" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  styleClass="p-text-left">
              </p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span *ngIf="updateValidity(createForm.controls.shipTerm)" class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.TradeTerm' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="shipTerm" optionLabel="label" optionValue="value"  [showClear]="true"
              [options]="shipTermOptions" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true" ></p-dropdown>

              <div *ngIf="((submitted || createForm.controls.shipTerm.touched) && createForm?.controls?.shipTerm?.errors?.required)" >
                <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
              </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.ReceivingTime' | translate }}</label>
          <div class="item">
            <p-calendar formControlName="whDt" [showTime]="true"   appendTo = 'body'
              [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" dateFormat="yy/mm/dd"   >
            </p-calendar>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.EstimateArrivalDate' | translate }}</label>
          <div class="item">
            <p-calendar formControlName="expectedDt" [showTime]="true"   appendTo = 'body'
              [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" dateFormat="yy/mm/dd"   >
            </p-calendar>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span *ngIf="updateValidity(createForm.controls.hawbNo)" class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.HAWB' | translate }}</label>
          <div class="item">
            <input pInputText formControlName="hawbNo" />

            <div *ngIf="((submitted || createForm.controls.hawbNo.touched) && createForm?.controls?.hawbNo?.errors?.required)" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.NumPallets' | translate }}</label>
          <div class="item">
            <p-inputNumber   formControlName="palletCnt" ></p-inputNumber>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span *ngIf="updateValidity(createForm.controls.totalCartonCnt)" class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.TotalCartonCnt' | translate }}</label>
          <div class="item">
            <p-inputNumber   formControlName="totalCartonCnt" ></p-inputNumber>

            <div *ngIf="((submitted || createForm.controls.totalCartonCnt.touched) && createForm?.controls?.totalCartonCnt?.errors?.required)" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>

          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span *ngIf="updateValidity(createForm.controls.totalChargeableWeight)" class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.TotalChargeableWeight' | translate }}</label>
          <div class="item">
            <p-inputNumber   formControlName="totalChargeableWeight" mode="decimal" [minFractionDigits]="2" ></p-inputNumber>

            <div *ngIf="((submitted || createForm.controls.totalChargeableWeight.touched) && createForm?.controls?.totalChargeableWeight?.errors?.required)" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.TotalGrossWeight' | translate }}</label>
          <div class="item">
            <p-inputNumber   formControlName="totalGrossWeight" mode="decimal" [minFractionDigits]="2" ></p-inputNumber>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.TotalVolumeWeight' | translate }}</label>
          <div class="item">
            <p-inputNumber   formControlName="totalVolumeWeight" mode="decimal" [minFractionDigits]="2" ></p-inputNumber>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.NumCartonsReceived' | translate }}</label>
          <div class="item">
            <p-inputNumber   formControlName="rfCaseCnt" [disabled]=true ></p-inputNumber>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.TotalQty' | translate }}</label>
          <div class="item">
            <p-inputNumber  formControlName="totalQty"  ></p-inputNumber>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.ActualQty' | translate }}</label>
          <div class="item">
            <p-inputNumber   formControlName="cartonCnt"  [disabled]=true ></p-inputNumber>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.CalculationUnit' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="uom" optionLabel="label" optionValue="value"  [showClear]="true"
              [options]="carTypeOptions" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true"  styleClass="p-text-left" ></p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.CalculateQty' | translate }}</label>
          <div class="item">
            <p-inputNumber   formControlName="uomQty" ></p-inputNumber>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.CustomsBondedNum' | translate }}</label>
          <div class="item">
            <input pInputText formControlName="bondedNo" />
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.LooseCargoNum' | translate }}</label>
          <div class="item">
            <input pInputText formControlName="bulkCargoNo" />
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.Brand' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="brand" optionLabel="label" optionValue="value"  [showClear]="true"
              [options]="brandOptions" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true"  styleClass="p-text-left" [virtualScroll]="true" [itemSize]="10"></p-dropdown>

          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.ReasonNonReceiving' | translate }}</label>
          <div class="item">
            <p-dropdown optionLabel="label" optionValue="value"  [showClear]="true" formControlName="shippingRemark"
              [options]="shippingRemarkOptions" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true"  styleClass="p-text-left" ></p-dropdown>

          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.DropShipment' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="isDropShipment" optionLabel="label" optionValue="value"
            [options]="yesNoOptions"   styleClass="p-text-left" ></p-dropdown>

            <div *ngIf="((submitted || createForm.controls.isDropShipment.touched) && createForm?.controls?.isDropShipment?.errors?.required)" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.GenerateExpenses' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="isGenerateFee" optionLabel="label" optionValue="value"
            [options]="yesNoOptions"   styleClass="p-text-left" ></p-dropdown>

            <div *ngIf="((submitted || createForm.controls.isGenerateFee.touched) && createForm?.controls?.isGenerateFee?.errors?.required)" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.WarehouseAddress' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="addressCode" optionLabel="label" optionValue="value"
                [options]="pickupLocationOptions" placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [showClear]="true"
                styleClass="p-text-left"></p-dropdown>

                <div *ngIf="((submitted || createForm.controls.addressCode.touched) && createForm?.controls?.addressCode?.errors?.required)" >
                  <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
                </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.PickUpAddress' | translate }}</label>
          <div class="item">
            <input pInputText formControlName="deliveryAddress" />
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.IsUrgent' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="urgentFlag" optionLabel="label" optionValue="value"
            [options]="urgentFlagOptions"   styleClass="p-text-left" ></p-dropdown>

            <div *ngIf="((submitted || createForm.controls.urgentFlag.touched) && createForm?.controls?.urgentFlag?.errors?.required)" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.FlightNum' | translate }}</label>
          <div class="item">
            <input pInputText formControlName="flightNo" />
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.FlightDate' | translate }}</label>
          <div class="item">
            <p-calendar formControlName="flightDt" [showTime]="true"   appendTo = 'body'
              [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" dateFormat="yy/mm/dd"   >
            </p-calendar>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.DeliveryMode' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="shippingMethod" optionLabel="label" optionValue="value"  filterBy="value"
              [options]="shipMethodOptions" placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [showClear]="true"
              styleClass="p-text-left"></p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.MAWB' | translate }}</label>
          <div class="item">
            <input pInputText formControlName="mawbNo" />
          </div>
        </div>

        <div class="field col-12 lg:col-6 mb-3">
          <div>{{ 'ReceivingRegistration.MainTable.IdentificaitonNum' | translate }} </div>
          <div class="formgrid grid align-center vertical-container">
            <div class="col-12 md:col lg:col"><input pInputText formControlName="docNo1" maxlength="2"  /> </div><span>/</span>
            <div class="col-12 md:col lg:col"><input pInputText formControlName="docNo2" maxlength="2"  /> </div><span>/</span>
            <div class="col-12 md:col lg:col"><input pInputText formControlName="docNo3" maxlength="2"  /> </div><span>/</span>
            <div class="col-12 md:col lg:col"><input pInputText formControlName="docNo4" maxlength="4"  /> </div><span>/</span>
            <div class="col-12 md:col lg:col"><input pInputText formControlName="docNo5" maxlength="5"  /> </div>
          </div>
          <small *ngIf="(f.docNo1.errors || f.docNo2.errors || f.docNo3.errors || f.docNo4.errors || f.docNo5.errors)" class="errors">
            <div *ngIf="f.docNo1.errors?.fullWidth || f.docNo2.errors?.fullWidth || f.docNo3.errors?.fullWidth || f.docNo4.errors?.fullWidth || f.docNo5.errors?.fullWidth" class="p-invalid">請輸入半形字符</div>
          </small>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span class="requiredStart">*</span>{{ 'ReceivingRegistration.MainTable.DocumentSubType' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="deliverySubType" optionLabel="label" optionValue="value"
                [options]="deliverySubOptions"  styleClass="p-text-left"></p-dropdown>

            <div *ngIf="((submitted || createForm.controls.deliverySubType.touched) && createForm?.controls?.deliverySubType?.errors?.required)" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.DONum' | translate }}</label>
          <div class="item">
            <input pInputText formControlName="doNo" />
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.ExpensesDistribution' | translate }}</label>
          <div class="item">
            <input pInputText formControlName="splitDept" />
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.RFQSetting' | translate }}</label>
          <div class="item">
            <input pInputText formControlName="quotationKey"  [attr.disabled]="true" />
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label><span class="requiredStart">*</span>{{ 'WarehousingAbnormal.Form.IsAbnormalNotify' | translate }}</label>
          <p-dropdown formControlName="isAbnormalNotify" optionLabel="label" optionValue="value"
            [options]=" yesNoOptions" styleClass="p-text-left"
            [showClear]="false" placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
          </p-dropdown>
        </div>
        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.Creator' | translate }}</label>
          <div class="item mt-2">
            {{ createForm?.value.createUser }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.CreationTime' | translate }}</label>
          <div class="item mt-2">
            {{ createForm?.value.createDt  | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone  }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.UpdateBy' | translate }}</label>
          <div class="item mt-2">
            {{ createForm?.value.updateUser }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceivingRegistration.MainTable.EditTime' | translate }}</label>
          <div class="item mt-2">
            {{ createForm?.value.updateDt  | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone  }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceiptFormHeaderDetails.ConsolidationForwarder' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="consolidationForwarder" optionLabel="optionDesc" optionValue="optionCode"
              [options]="bookingForwarderOptions" [filter]="true" [showClear]="true" filterBy="optionDesc"  (onChange)="changeBillObject(1)"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}" ></p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'ReceiptFormHeaderDetails.CrossBoundryForwarder' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="crossBoundryForwarder" optionLabel="optionDesc" optionValue="optionCode"
              [options]="bookingForwarderOptions" [filter]="true" [showClear]="true" filterBy="optionDesc"  (onChange)="changeBillObject(1)"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}" ></p-dropdown>
          </div>
        </div>
          <!-- 起運地位置選擇 - 使用連動元件 -->
        <laas-location-cascade-dropdown
          formControlName="consolidationFromLocation"
          [showCountry]="true"
          [showCity]="true"
          [showArea]="true"
          [showExpressArea]="false"
          [showDistrict]="false"
          [submitted]="submitted"
          countryLabel="{{ 'ReceiptFormHeaderDetails.ConsolidationFromCountry' | translate }}"
          cityLabel="{{ 'ReceiptFormHeaderDetails.ConsolidationFromCity' | translate }}"
          areaLabel="{{ 'ReceiptFormHeaderDetails.ConsolidationFromArea' | translate }}"
          countryPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          cityPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          areaPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          [allowAllOption]="false"
          [showClear]="true"
          [enableFilter]="true"
          [cssClasses]="'col-12 md:col-6 lg:col-3 mb-3'">
        </laas-location-cascade-dropdown>

        <!-- 目的地位置選擇 - 使用連動元件 -->
        <laas-location-cascade-dropdown
          formControlName="consolidationToLocation"
          [showCountry]="true"
          [showCity]="true"
          [showArea]="true"
          [showExpressArea]="false"
          [showDistrict]="false"
          countryLabel="{{ 'ReceiptFormHeaderDetails.ConsolidationToCountry' | translate }}"
          cityLabel="{{ 'ReceiptFormHeaderDetails.ConsolidationToCity' | translate }}"
          areaLabel="{{ 'ReceiptFormHeaderDetails.ConsolidationToArea' | translate }}"
          countryPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          cityPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          areaPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          [allowAllOption]="false"
          [showClear]="true"
          [enableFilter]="true"
          [cssClasses]="'col-12 md:col-6 lg:col-3 mb-3'">
        </laas-location-cascade-dropdown>
      </div>
      <div class="grid">
        <div class="p-co2">
            <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}"      (click)="createClick()"></button>
        </div>
      </div>

    </form>
  </p-card>

</div>

<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
